import { referrerDetector } from 'api/referrerDetector'
import image from 'assets/image/auth-steps/unAuth.png'
import { AuthTemplate } from 'components/templates/authTemplate'
import { CONSTS } from 'config/objectConst.js'
import { useHistory } from 'react-router-dom'
import { notifyError } from 'shared/errors/notificate'
import { useAppSelector } from 'shared/hooks/store'
import { typo } from 'shared/styles'
import { Button } from 'shared/ui'

import { appSelectors } from '../../../../redux/reducers/app'

const TITLE = `My name is ${CONSTS.PROJECT_NAME} & I am here to help you!`

const cn = AuthTemplate.cn

export function NoAuth() {
	const { location } = useHistory()
	const connector = useAppSelector(appSelectors.connector)
	return (
		<AuthTemplate active={2}>
			<h1 className={cn.title}>{TITLE}</h1>
			<img
				alt='Our mascot introduce themself with thumbs up'
				className={cn.image}
				height={210}
				src={image}
				width={140}
			/>

			<Button
				className={cn.action}
				onClick={() => {
					const referrer = referrerDetector.get()
					connector.auth.signIn(location.pathname, referrer).catch(notifyError)
				}}
				type='button'
				typography={typo.largeButton}
				variant='bordered'
			>
				Sign In
			</Button>
		</AuthTemplate>
	)
}
